export const interiorFeatures = [
    '2 Primary Baths',
    '2 Primary Suites',
    'Bar',
    'Bidet',
    'Bookcases',
    'Breakfast Bar',
    'Built-in Features',
    'Cedar Closet(s)',
    'Ceiling Fan(s)',
    'Ceiling(s)-Beamed',
    'Ceiling(s)-Cathedral',
    'Ceiling(s)-Coffered',
    'Ceiling(s)-High',
    'Ceiling(s)-Tray',
    'Ceiling(s)-Vaulted',
    'Central Vacuum',
    'Chandelier',
    'Counter-Corian',
    'Counter-Granite',
    'Counter-Laminate',
    'Counter-Quartz',
    'Counter-Stone',
    'Counter-Tile',
    'Crown Molding',
    'Double Vanity',
    'Dry Bar',
    'Dryer-Electric Hookup',
    'Dryer-Gas Hookup',
    'Dumbwaiter',
    'Eat-in Kitchen',
    'Elevator',
    'Entrance Foyer',
    'French Doors',
    'High Speed Internet',
    'In-Law Floorplan',
    'Intercom',
    'Interior Steps',
    'Kitchen Island',
    'Low Flow Plumbing Fixtures',
    'Multiple Dining Areas',
    'Multiple Living Areas',
    'Murphy Bed',
    'Natural Woodwork',
    'No Interior Steps',
    'Open Floorplan',
    'Pantry',
    'Primary Bedroom on Main',
    'Recessed Lighting',
    'Sauna',
    'Smart Home',
    'Smart Thermostat',
    'Soaking Tub',
    'Solar Tube(s)',
    'Sound System',
    'Stackable W/D Connections',
    'Storage',
    'Track Lighting',
    'Two Primary Closets',
    'Walk-In Closet(s)',
    'Washer Hookup',
    'WaterSense Fixture(s)',
    'Wet Bar',
    'Wired for Data',
    'Wired for Sound',
    'None',
    'See Remarks'
];

export const exteriorFeatures = [
    'Balcony',
    'Barbecue',
    'Basketball Court',
    'Boat Dock - Private',
    'Boat Dock - Shared',
    'Boat Lift',
    'Boat Lock',
    'Boat Ramp',
    'Boat Slip',
    'Courtyard-Covered',
    'Courtyard-Uncovered',
    'Dog Run',
    'Electric Car Plug-in',
    'Exterior Steps',
    'Garden',
    'Gray Water System',
    'Grill-Electric',
    'Grill-Gas',
    'Gutters-Full',
    'Gutters-Partial',
    'Kennel',
    'Lighting',
    'Misting System',
    'No Exterior Steps',
    'Outdoor Grill',
    'Permeable Paving',
    'Pest Tubes in Walls',
    'Playground',
    'Private Entrance',
    'Private Yard',
    'Restricted Access',
    'RV Hookup',
    'Satellite Dish Leased',
    'Satellite Dish Owned',
    'Sport Court',
    'Tennis Court(s)',
    'See Remarks',
    'None'
];

export const appliances = [
    'Bar Fridge',
    'Built-In Electric Oven',
    'Built-In Electric Range',
    'Built-In Freezer',
    'Built-In Gas Oven',
    'Built-In Gas Range',
    'Built-In Oven(s)',
    'Built-In Range',
    'Built-In Refrigerator',
    'Convection Oven',
    'Cooktop',
    'Dishwasher',
    'Disposal',
    'Down Draft',
    'Dryer',
    'Electric Cooktop',
    'Electric Range',
    'ENERGY STAR Qualified Appliances',
    'ENERGY STAR Qualified Dishwasher',
    'ENERGY STAR Qualified Dryer',
    'ENERGY STAR Qualified Freezer',
    'ENERGY STAR Qualified Refrigerator',
    'ENERGY STAR Qualified Washer',
    'ENERGY STAR Qualified Water Heater',
    'Exhaust Fan',
    'Freezer',
    'Freezer Free-Standing',
    'Gas Cooktop',
    'Gas Range',
    'Humidifier',
    'Ice Maker',
    'Indoor Grill',
    'Induction Cooktop',
    'Instant Hot Water',
    'Microwave',
    'None',
    'Oven',
    'Oven Electric',
    'Oven Free-Standing Electric',
    'Oven Free-Standing Gas',
    'Oven Gas',
    'Oven-Double',
    'Plumbed For Ice Maker',
    'Portable Dishwasher',
    'Propane Cooktop',
    'Range',
    'Range Free Standing Electric',
    'Range Free-Standing',
    'Range Free-Standing Gas',
    'Range Hood',
    'Refrigerator',
    'Refrigerator Free-Standing',
    'See Remarks',
    'Self Cleaning Oven',
    'Solar Hot Water',
    'Stainless Steel Appliance(s)',
    'Trash Compactor',
    'Vented Exhaust Fan',
    'Warming Drawer',
    'Washer',
    'Washer/Dryer',
    'Washer/Dryer Stacked',
    'Water Heater-Electric',
    'Water Heater-Gas',
    'Water Heater-Tankless',
    'Water Purifier',
    'Water Purifier Owned',
    'Water Purifier Rented',
    'Water Softener',
    'Water Softener Owned',
    'Water Softener Rented',
    'Wine Cooler',
    'Wine Refrigerator'
];

export const windowFeatures = [
    'Aluminum Frames',
    'Bay Window(s)',
    'Blinds',
    'Display Window(s)',
    'Drapes',
    'Dual Pane Windows',
    'ENERGY STAR Qualified Windows',
    'Garden Window(s)',
    'Insulated Windows',
    'Low Emissivity Windows',
    'Plantation Shutters',
    'Screens',
    'Shutters',
    'Skylight',
    'Solar Screens',
    'Storm Window(s)',
    'Tinted Windows',
    'Triple Pane Windows',
    'Vinyl Windows',
    'Window Coverings',
    'Window Treatments',
    'Wood Frames',
    'None',
    'See Remarks'
];

export const securityFeatures = [
    '24 Hour Security',
    'Building Security',
    'Carbon Monoxide Detector(s)',
    'Closed Circuit Camera(s)',
    'Fire Alarm',
    'Fire Escape',
    'Fire Sprinkler System',
    'Firewall(s)',
    'Gated with Guard',
    'Key Card Entry',
    'Panic Alarm',
    'Prewired',
    'Secured Garage/Parking',
    'Security Fence',
    'Security Guard',
    'Security Lights',
    'Security Service',
    'Security System',
    'Security System Leased',
    'Security System Owned',
    'Smoke Detector(s)',
    'Window Bars',
    'Window Bars with Quick Release',
    'None',
    'See Remarks'
];

export const accessibilityFeatures = [
    'Adaptable Bathroom Walls',
    'Adaptable For Elevator',
    'Approach with Ramp',
    'Bedroom',
    'Ceiling Track',
    'Central Living Area',
    'Closets',
    'Common Area',
    'Customized Wheelchair Accessible',
    'Doors',
    'Electronic Environmental Controls',
    'Elevator Installed',
    'Enhanced Accessibility',
    'Entrance',
    'Exterior Wheelchair Lift',
    'For Hearing-Impairment',
    'Full Bath',
    'Fully Accessible',
    'Grip-Accessible Features',
    'Hallway(s)',
    'Hand Rails',
    'Kitchen',
    'Kitchen Appliances',
    'Lower Fixtures',
    'Reinforced Floors',
    'Safe Emergency Egress from Home',
    'Smart Technology',
    'Stair Lift',
    'Stairway',
    'Standby Generator',
    'Therapeutic Whirlpool',
    'Visitable',
    'Visitor Bathroom',
    'Walker-Accessible Stairs',
    'Washer/Dryer',
    'None',
    'See Remarks'
];

export const laundryLocation = [
    'Common Area',
    'In Basement',
    'In Bathroom',
    'In Carport',
    'In Garage',
    'In Hall',
    'In Kitchen',
    'In Unit',
    'Inside',
    'Laundry Closet',
    'Laundry Room',
    'Lower Level',
    'Main Level',
    'Multiple Locations',
    'Outside',
    'Upper Level',
    'None',
    'See Remarks'
];

export const patioAndPorchFeatures = [
    'Arbor',
    'Awning(s)',
    'Covered',
    'Deck',
    'Enclosed',
    'Front Porch',
    'Glass Enclosed',
    'Mosquito System',
    'Patio',
    'Porch',
    'Rear Porch',
    'Screened',
    'Side Porch',
    'Terrace',
    'Wrap Around',
    'See Remarks',
    'None'
];

export const privatePoolFeatures = [
    'Above Ground',
    'Black Bottom',
    'Cabana',
    'Diving Board',
    'Electric Heat',
    'ENERGY STAR Qualified pool pump',
    'Fenced',
    'Fiberglass',
    'Filtered',
    'Gunite',
    'Heated',
    'In Ground',
    'Indoor',
    'Infinity',
    'Lap',
    'Liner',
    'Outdoor Pool',
    'Pool Cover',
    'Pool Sweep',
    'Pool/Spa Combo',
    'Rooftop Pool',
    'Saltwater',
    'Screen Enclosure',
    'Solar Cover',
    'Solar Heat',
    'Sport',
    'Tile',
    'Vinyl',
    'Waterfall',
    'None',
    'See Remarks'
];

export const spaFeatures = ['Above Ground', 'Bath', 'Fiberglass', 'Gunite', 'Heated', 'Hot Tub', 'In Ground', 'None', 'See Remarks'];
export const horseAmenities = [
    'Arena',
    'Barn',
    'Boarding Facilities',
    'Bridle Path',
    'Corral(s)',
    'Hay Storage',
    'Paddocks',
    'Palpation Chute',
    'Pasture',
    'Riding Trail',
    'Round Pen',
    'Shaving Bin',
    'Stable(s)',
    'Tack Room',
    'Trailer Storage',
    'Wash Rack',
    'None',
    'See Remarks'
];

export const fencing = [
    'Back Yard',
    'Barbed Wire',
    'Block',
    'Brick',
    'Chain Link',
    'Cross Fenced',
    'Electric',
    'Fenced',
    'Front Yard',
    'Full',
    'Gate',
    'Invisible',
    'Livestock',
    'Masonry',
    'Partial',
    'Perimeter',
    'Pipe',
    'Privacy',
    'Security',
    'Slump Stone',
    'Split Rail',
    'Stone',
    'Vinyl',
    'Wire',
    'Wood',
    'Wrought Iron',
    'None',
    'See Remarks'
];

export const fireplaceFeatures = [
    'Basement',
    'Bathroom',
    'Bedroom',
    'Blower Fan',
    'Circulating',
    'Decorative',
    'Den',
    'Dining Room',
    'Double Sided',
    'Electric',
    'EPA Certified Wood Stove',
    'EPA Qualified Fireplace',
    'Factory Built',
    'Family Room',
    'Fire Pit',
    'Free Standing',
    'Gas',
    'Gas Log',
    'Gas Starter',
    'Glass Doors',
    'Great Room',
    'Heatilator',
    'Insert',
    'Kitchen',
    'Library',
    'Living Room',
    'Masonry',
    'Metal',
    'Outside',
    'Pellet Stove',
    'Primary Bedroom',
    'Propane',
    'Raised Hearth',
    'Recreation Room',
    'Sealed Combustion',
    'See Through',
    'Stone',
    'Ventless',
    'Wood Burning',
    'Zero Clearance',
    'None',
    'See Remarks'
];

export const otherStructures = [
    'Airplane Hangar',
    'Arena',
    'Barn(s)',
    'Bathroom',
    'Boat House',
    'Cabana',
    'Cave(s)',
    'Corral(s)',
    'Covered Arena',
    'Garage(s)',
    'Gazebo',
    'Grain Storage',
    'Greenhouse',
    'Guest House',
    'Kennel/Dog Run',
    'Mobile Home',
    'Outbuilding',
    'Outdoor Kitchen',
    'Packing Shed',
    'Pergola',
    'Pool House',
    'Poultry Coop',
    'Residence',
    'RV/Boat Storage',
    'Second Residence',
    'Shed',
    'Storage',
    'Tennis Court(s)',
    'Workshop',
    'None',
    'See Remarks'
];

export const communityFeatures = [
    'Airport/Runway',
    'BBQ Pit/Grill',
    'Bike Storage/Locker',
    'Business Center',
    'Car Share Available',
    'Clubhouse',
    'Cluster Mailbox',
    'Common Grounds',
    'Concierge',
    'Conference/Meeting Room',
    'Controlled Access',
    'Courtyard',
    'Covered Parking',
    'Creative Office Space',
    'Curbs',
    'Designated Car-2-Go Space(s)',
    'Dog Park/Play Area',
    'Electronic Payments',
    'Equestrian Community',
    'Fishing',
    'Fitness Center',
    'Game Room',
    'Garage Parking',
    'Gated',
    'General Aircraft Airport',
    'Golf Course',
    'Google Fiber',
    'High Speed Internet',
    'Hot Tub Community',
    'Housekeeping',
    'Kitchen Facilities',
    'Lake',
    'Laundry Facility(s)',
    'Laundry Service',
    'Library',
    'Lock and Leave',
    'Lounge',
    'Maintenance On-Site',
    'Media Center/Movie Theatre',
    'Mini-Golf',
    'Nest Thermostat',
    'On-Site Retail',
    'Online Services',
    'Package Service',
    'Park',
    'Pet Amenities',
    'Picnic Area',
    'Planned Social Activities',
    'Playground',
    'Pool',
    'Property Manager On-Site',
    'Putting Green',
    'Racquetball',
    'Recycling Area/Center',
    'Restaurant',
    'Rooftop Lounge',
    'Room Service',
    'Sauna',
    'Shopping Mall',
    'Sidewalks',
    'Smart Car Charging',
    'Spa/Hot Tub',
    'Sport Court(s)/Facility',
    'Stable(s)',
    'Storage',
    'Street Lights',
    'Suburban',
    'Sundeck',
    'Tanning Salon',
    'Tenant Access Cargo Elevator',
    'Tennis Court(s)',
    'Trash Pickup - Door to Door',
    'U-Verse',
    'Underground Utilities',
    'Valet Parking',
    'Walk/Bike/Hike/Jog Trail(s)',
    'None',
    'See Remarks'
];

export const guestAccommodations = [
    'Connected',
    'Garage Apartment',
    'Guest House',
    'Main Level',
    'Not Connected',
    'Room with Private Bath',
    'Separate Entrance',
    'Separate Kit Facilities',
    'Separate Living Quarters',
    'Separate Utilities',
    'None',
    'See Remarks'
];

export const furnished = ['Furnished', 'Negotiable', 'Partially Furnished', 'Unfurnished'];

export const appliancesMaintained = [
    'BBQ',
    'Cook Top',
    'Dishwasher',
    'Disposal',
    'Dryer',
    'Ice Maker',
    'Microwave Oven',
    'Range/Oven/Stove',
    'Refrigerator',
    'Trash Compactor',
    'Washer',
    'Water Heater',
    'See Attachment',
    'None',
    'See Remarks'
];
